/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'

import NoAccess from '../../components/NoAccess'
import { AppContext } from '../../AppContext'

import InternalKeysSection from './InternalKeysSection'
import KeyNestSection from './KeyNestSection'
import LockBoxSection from './LockBoxSection'
import TopBar from './TopBar'

function KeysPage () {
  const profile = React.useContext(AppContext).profile || {}
  const canReadLockBox = profile?.isAdmin || profile?.readLockBox
  const canReadInternalKeys = profile?.isAdmin || profile?.readInternalKey
  const canReadKeys = profile?.isAdmin || profile?.readKeys
  const hasReadAccess = canReadKeys || canReadLockBox || canReadInternalKeys

  const initialType = canReadLockBox
    ? 'lockBox'
    : canReadInternalKeys ? 'internalKeys' : 'keyNest'

  const [totalCount, setTotalCount] = React.useState(0)
  const [totalLoading, setTotalLoading] = React.useState(true)

  const [lockBoxParams, setLockBoxParams] = React.useState({
    search: '',
    status: undefined,
    pageSize: 20,
  })

  const [internalKeysParams, setInternalKeysParams] = React.useState({
    searchInternalKey: '',
    internalKeyStatus: undefined,
    boxType: undefined,
    pageSize: 20,
  })

  const [keyNestParams, setKeyNestParams] = React.useState({
    searchKeys: '',
    keyType: '',
    pageSize: 20,
  })

  const [type, setType] = React.useState(initialType)
  const [city, setCity] = React.useState(undefined)

  const [refetchLockBoxCollection, setRefetchLockBoxCollection] = React.useState(
    false)
  const [refetchInternalKeysCollection, setRefetchInternalKeysCollection] = React.useState(
    false)

  const triggerLockBoxCollectionRefetch = () => {
    setRefetchLockBoxCollection(prev => !prev)
  }

  const triggerInternalKeysCollectionRefetch = () => {
    setRefetchInternalKeysCollection(prev => !prev)
  }

  if (profile?._id && !hasReadAccess) {
    return <NoAccess/>
  }

  return (
    <div className="px-5 pb-5 pt-3">
      <TopBar
        triggerLockBoxCollectionRefetch={triggerLockBoxCollectionRefetch}
        triggerInternalKeysCollectionRefetch={triggerInternalKeysCollectionRefetch}
        setInternalKeysFilters={setInternalKeysParams}
        internalKeysFilters={internalKeysParams}
        setLockBoxFilters={setLockBoxParams}
        setKeyNestFilters={setKeyNestParams}
        lockBoxFilters={lockBoxParams}
        totalLoading={totalLoading}
        totalCount={totalCount}
        setType={setType}
        setCity={setCity}
        city={city}
        type={type}
      />

      {canReadLockBox && type === 'lockBox' && (
        <LockBoxSection
          triggerRefetchCollection={triggerLockBoxCollectionRefetch}
          refetchCollection={refetchLockBoxCollection}
          setTotalLoading={setTotalLoading}
          setTotalCount={setTotalCount}
          setParams={setLockBoxParams}
          params={lockBoxParams}
          city={city}
        />
      )}

      {canReadInternalKeys && type === 'internalKeys' && (
        <InternalKeysSection
          triggerRefetchCollection={triggerInternalKeysCollectionRefetch}
          refetchCollection={refetchInternalKeysCollection}
          setParams={setInternalKeysParams}
          setTotalLoading={setTotalLoading}
          setTotalCount={setTotalCount}
          params={internalKeysParams}
          city={city}
        />
      )}

      {canReadKeys && type === 'keyNest' && (
        <KeyNestSection
          setTotalLoading={setTotalLoading}
          setTotalCount={setTotalCount}
          setParams={setKeyNestParams}
          params={keyNestParams}
          city={city}
        />
      )}
    </div>
  )
}

export default KeysPage
